export default __webpack_public_path__ + "static/media/1.7eefd4c0.jpg";